exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-dc5a9dfc] .el-card__body{height:100%}", ""]);

// exports
